import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { TopBar } from "../../../shared/topBar/TopBar";
import { useDispatch, useSelector } from "react-redux";
import { UrlPath } from "../../../../config/routeConfig";
import { SBADropDown } from "../../../UiComponents/SBADropDown";
import { ToastContainer, toast } from 'react-toastify';
import { getStrategy} from "../../../actions/assetDetailsActions";
import { insertorUpdateMarketData,getEnumerations} from "../../../../config/apiConfig";
import {getDataSource,getEnumeration } from '../../../actions/CommonAction';
import $ from"jquery";
import { sbaAxios } from "../../../utils/sbaAxios";
export const MarketDataAdd =()=>
{

  const params = useParams();
  const history = useNavigate();
  let Level = ([{ BreadCrumb: "Market Data >", Routes: `${UrlPath.MarketData}` }]);
  const Gstate = useSelector(state => { return state; }) || {};
  const dispatch = useDispatch();
  const Strategy = Gstate.strategy.strategy;
  const Enumerationdata=Gstate.enumValues.enumValues||[];
  const [selectedMarketName, setselectedMarketName] = useState();
  const [selectedMarketSymbol, setselectedMarketSymbol] = useState();
  const [selectedStrategy, setSelectedStrategy] = useState();
  const [selectedStrategyId, setSelectedStrategyId] = useState();
  const [selectedDS, setSelectedDS] = useState();
  const [selectedDSId, setSelectedDSId] = useState();
  const [selectedNotes, setSelectedNotes] = useState();
  const [selectedprimary,setSelectedPrimary]=useState();
  const [selectedenum,setSelectedEnum]=useState();
  const [selectedenumId,setSelectedEnumId]=useState();
  const[reportingGroup,setReportingGroup]=useState();
  const[selectedreportingGroup,setSelectedReportingGroup]=useState();
  const DataSource= Gstate.DataSourcelist.DataSourcelist || [];
  useEffect(() => {
    dispatch(getStrategy());
  dispatch(getDataSource(3));
  setSelectedStrategy({"ClassificationId": null,"ClassificationValue": "--Please Select--",});
  setSelectedReportingGroup({"EnumValue": null,"EnumName": "--Please Select--"})

  dispatch(getEnumeration("MarketIndexType"));
   getReportingGroup();

  }, []);
  useEffect(() => {
    setSelectedEnum({EnumValue:Enumerationdata[0]?.EnumValue,EnumName:Enumerationdata[0]?.EnumName});
    setSelectedDS({DataSourceId: DataSource[0]?.DataSourceId, DataSourceName: DataSource[0]?.DataSourceName});
    setSelectedEnumId(Enumerationdata[0]?.EnumValue);
    setSelectedDSId(DataSource[0]?.DataSourceId);
  },[Enumerationdata]);
  
  const strategyDropdownChange = (e) => {
    setSelectedStrategy(e.value);
    setSelectedStrategyId(e.value.ClassificationId);
  };
  const marketNameChange = (event) => {
    setselectedMarketName(event.target.value);
  };
  const shortNameChange = (event) => {
    setselectedMarketSymbol(event.target.value);
  };
  const dsChange = (e) => {
    setSelectedDS(e.value);
    setSelectedDSId(e.value.DataSourceId);
    
  };

  const NotesChange = (event) => {
    setSelectedNotes(event.target.value);

    };
    const chkChange = () => {
        const primary=$("#chktype").prop("checked");
        setSelectedPrimary(primary);
    
        };
        const  enumOnchange = (e) => {
         
          setSelectedEnum(e.value);
          setSelectedEnumId(e.value.EnumValue);
          };
       
  const ReportingGroupddChange=(e)=>
  {
    setSelectedReportingGroup(e.value);
  }
const cancelnavigate=()=>
      {
        history(`${UrlPath.MarketData}`);
      }

      const getReportingGroup = async () => {
        try {
            const response = await sbaAxios({
                url: `${getEnumerations}${'Reporting Group'}`,
                method: 'get',
            });
            setReportingGroup(response);
        } catch (error) {
            console.error("Error fetching Reporting Group from API:", error);
        }
    };

//-- Save  Market Details--
const AddMarketDataDetails = (event) => {
     event.preventDefault();
     let saveSuccess = true;
     let errorMsg = [];
     // Prepare the data to be sent in the POST request
     const data = {
       "MarketIndexId": 0,
       "MarketIndexName": selectedMarketName,
       "MarketIndexShortName": selectedMarketSymbol,
       "DataSourceId": selectedDSId,
       "MarketIndexTypeId":selectedenumId ,
       "IsPrimary": selectedprimary,
       "ConstituentId": selectedreportingGroup.EnumValue||0,
       "StrategyId":selectedStrategyId,
       "IndexNotes":selectedNotes,
       "ModifiedBy": 38
         };
     if (!selectedMarketName) {
       saveSuccess = false;
       errorMsg.push("Please Enter Market Name");
     }
     if (!selectedMarketSymbol) {
         saveSuccess = false;
         errorMsg.push("Please Enter Market Symbol");
       }
    
     if (saveSuccess) {
      sbaAxios({
        url: `${insertorUpdateMarketData}`,
        method: 'post',
        data: data,
    })
    .then((response) => {
            if(response=== -3999)
            {
              toast.error('Market Data cannot be saved because name or Symbol is not unique.', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
              }) 
          }
          else
          {
           
            toast.success('Market Data Saved Successfully', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setTimeout(() => {
              history(`${UrlPath.MarketData}`);
            }, 1000);
          }
         })
    
         .catch((error) => {
           console.error(error);
         });
     }
     else {
       let ErrorString = "";
       errorMsg.map(item => { ErrorString = `${ErrorString}${item} \n` });
       console.log(errorMsg);
       toast.error(ErrorString, {
         position: "top-right",
         autoClose: 5000,
         hideProgressBar: false,
         closeOnClick: true,
         pauseOnHover: false,
         draggable: true,
         progress: undefined,
         theme: "light",
       })
     }
   };
return (
    <div>

          <TopBar label={"Market Data Add"} />
          <BreadCrumbs Levels={Level} />
          <div id="content" class="asset-detail-screen mainContentData">
            <div class="p-4">
                <div id="manfield" className="p-3 life-science rounded">
                  <div className="row ">
                    <div className="col-md-4">
                      <div className="my-4">
                        <label className="label">Name<span className="mandatory">*</span></label>
                        <input
                                className="form-control w-75"
                                type="text"
                                onChange={marketNameChange}                           
                              />
                      </div>
                      <div className="my-1">
                        <label className="label">Symbol<span className="mandatory">*</span></label>
                        <input
                                className="form-control w-75"
                                type="text"
                                onChange={shortNameChange}          
                              />
                      </div>
                      <div  className="my-4">
                        <label className="label">Type</label>
                        <div>
                        <div  className="d-flex gap-3">
                  <SBADropDown  className="w-75"   textField={"EnumName"}
                                valueField={"EnumValue"}  data={Enumerationdata} onChange={enumOnchange} value={selectedenum}></SBADropDown>
                  </div>
                                              </div>
                      </div>
                      <div className="my-4">
                        <label className="label">Data source</label>
                        <div>
                        <SBADropDown
                                className="w-75"  
                                value={selectedDS}
                                data={DataSource}  
                                textField={"DataSourceName"}
                                valueField={"DataSourceId"}
                                onChange={dsChange}                  
                              />
                            
                        </div>
                        
                      </div>
                      <div className="my-4">
                      <label style={{ display: 'flex', alignItems: 'center' }}>
                      <input className="me-1"
                        type="checkbox" id="chktype"
                        onChange={chkChange}
                      />
                      <span>Primary</span>
                    </label>
                      </div>
                      <div className="my-4">
                      <label className="label">Strategy </label>
                        <div>
                        <SBADropDown
                                className='w-75'
                                value={
                                    selectedStrategy
                                  }
                                  textField={"ClassificationValue"}
                                  valueField={"ClassificationId"}
                                  data={Strategy}
  
                                  onChange={strategyDropdownChange}
                              />
                        </div>
                      </div>
                      <div className="my-4">
                      <label className="label">Reporting Group </label>
                        <div>
                        <SBADropDown
                                className='w-75'
                                value={
                                  selectedreportingGroup
                                  }
                                  textField={"EnumName"}
                                  valueField={"EnumValue"}
                                  data={reportingGroup}
  
                                  onChange={ReportingGroupddChange}
                              />
                        </div>
                      </div>
                      <div className="my-4" >
                        <label className="label">Notes	</label>
                        <div>
                        <textarea style={{ marginLeft: "2%" }} id="txtStrategydesc" className="form-control" rows={7} onChange={NotesChange}>
                        </textarea>
                        </div>
                      </div>
                     
                    </div>
                    <div className="col-lg-12 d-flex justify-content-lg-end p-0 align-items-center">
                      <button className="s-sm-btn mx-1" onClick={cancelnavigate} > Cancel</button>
                        <button className='p-sm-btn mx-1' onClick={AddMarketDataDetails} >Save</button>
                        </div>
                </div>

              </div>


            </div>
          </div>
          <ToastContainer></ToastContainer>
       
    </div>

  );
                    }